<template>
  <v-dialog :value="dialogProp.show" persistent max-width="900">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Добавление сессии ({0})', [ $t(SESSION_TYPE_ENUM[dialogProp.sessionType]) ]) }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col v-if="isLoading" cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col v-if="!!generalError" class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="px-3">
        <session-public-offers-info
            v-if="dialogProp.sessionType === SESSION_TYPES.PUBLIC_OFFERS"
            ref="session"
            :session-info="session"
            :lot="dialogProp.lot"
            create
            :validated="createSession" />
        <session-private-offers-info
            v-if="dialogProp.sessionType === SESSION_TYPES.PRIVATE_OFFERS"
            ref="session"
            :session-info="session"
            :lot="dialogProp.lot"
            create
            :validated="createSession" />
        <session-private-two-staged-offers-info
            v-if="dialogProp.sessionType === SESSION_TYPES.PRIVATE_TWO_STAGED_OFFERS"
            ref="session"
            :session-info="session"
            :lot="dialogProp.lot"
            create
            :validated="createSession" />
        <session-public-two-staged-offers-info
            v-if="dialogProp.sessionType === SESSION_TYPES.PUBLIC_TWO_STAGED_OFFERS"
            ref="session"
            :session-info="session"
            :lot="dialogProp.lot"
            create
            :validated="createSession" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import SessionPublicOffersInfo from './SessionPublicOffersInfo.vue'
  import SessionPrivateOffersInfo from './SessionPrivateOffersInfo.vue'
  import SessionPrivateTwoStagedOffersInfo from './SessionPrivateTwoStagedOffersInfo.vue'
  import SessionPublicTwoStagedOffersInfo from './SessionPublicTwoStagedOffersInfo.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { SESSION_TYPE_ENUM } from '@/constants/enums'
  import { SESSION_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOT_SESSIONS_MANAGEMENT, ORGANIZATION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      SessionPublicOffersInfo,
      SessionPrivateOffersInfo,
      SessionPrivateTwoStagedOffersInfo,
      SessionPublicTwoStagedOffersInfo
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lot: {
              lotId: null,
              lotType: null
            },
            sessionType: null,
            canViewStartPremiums: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        SESSION_TYPES,
        SESSION_TYPE_ENUM,
        isLoading: false
      }
    },
    computed: {
      ...mapState(LOT_SESSIONS_MANAGEMENT.NAMESPACE, {
        session: state => (state[LOT_SESSIONS_MANAGEMENT.STATE.TEMPLATE_SESSION] || { })
      })
    },
    created () {
      if (!this.dialogProp.lot.lotType ||
        !this.dialogProp.lot.lotId) {
        this.showErrorAction({
          message: this.$t('Торговая процедура не определена.')
        })
      }
      this.getSessionTemplate()
    },
    methods: {
      ...mapActions(LOT_SESSIONS_MANAGEMENT.NAMESPACE, {
        createSessionAction: LOT_SESSIONS_MANAGEMENT.ACTIONS.CREATE_SESSION,
        getTemplateSessionInfoAction: LOT_SESSIONS_MANAGEMENT.ACTIONS.GET_TEMPLATE_SESSION_INFO
      }),
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        clearOrganizationsShortInfoListAction: ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATIONS_SHORT_INFO_LIST
      }),
      getSessionTemplate: async function () {
        try {
          this.isLoading = true
          await this.getTemplateSessionInfoAction({
            lotId: this.dialogProp.lot.lotId,
            lotType: this.dialogProp.lot.lotType,
            sessionType: this.dialogProp.sessionType
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.session.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
          }
          this.cancel()
          this.clearOrganizationsShortInfoListAction()
        } catch (error) {
          this.throwIfUnknownError(error)
        } finally {
          this.isLoading = false
        }
      },
      createSession: async function (session) {
        const { organizationsPrepayments } = session

        if (!organizationsPrepayments ||
          organizationsPrepayments.some(op =>
            op.prepaymentPercentage === null ||
            op.prepaymentPercentage === '' ||
            op.prepaymentPercentage === undefined)) {
          throw new Vue.errorsTypes.ValidationError()
        }

        await this.createSessionAction({
          lotId: this.dialogProp.lot.lotId,
          lotType: this.dialogProp.lot.lotType,
          sessionType: this.dialogProp.sessionType,
          session
        })
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
